/**
 * 演示账号的凭据。**改密码只改这一个文件，同时后端 `.env` 的 `DEMO_PASS` 也要同步改。**
 *
 * ## 这串密码是公开的，而且没关系
 *
 * 它编译进前端 bundle，任何人打开 devtools 都能翻出来 —— 这一点无法回避。它之所以
 * 可以接受，是因为**拿着它进去也只能看到假数据**：
 *
 * 1. 演示实例由 `bin/hyperf-demo.php` 起，`DEMO_MODE` 写死在进程里，所有对小红书的
 *    调用在 `BaseService::callApi` 处被整体拦截，不出网
 * 2. 假数据只落共享库里 demo 自己的行（`advertiser_id >= 9000000000` / `user_id 999999` /
 *    `domain demo`），请求里越出区间的 `account_id` 会被直接拒绝
 * 3. 碰不到任何真实客户的数据，也不消耗任何 token
 *
 * ⚠️ **绝对不要把这里换成一个真实存在的账号密码。** 那样这串公开的字符就变成一个
 * 对外的真实登录口了，性质完全不同。要那么做的话，密码就不能写在前端。
 *
 * 注意两端耦合：前端这里预填的密码，就是发给后端 `demo/auth/login` 校验的那串，
 * 所以改了后端 `DEMO_PASS`，这里必须跟着改，否则「点进入」会提示账号或密码错误。
 */
export const DEMO_USERNAME = 'demo';
export const DEMO_PASSWORD = 'starseek2026';
